import fs from 'fs/promises';

const readFile = async (path: string) => fs.readFile(path, 'utf-8');
const writeFile = async (path: string, content: string) =>
  fs.writeFile(path, content, 'utf-8');

export default {
  readFile,
  writeFile,
};
